jQuery(document).ready(function($) {


    // product image zoom
   	$('.zoom').elevateZoom({
		gallery:"productThumbs",
        zoomType: "inner",
        cursor: "zoom-in",
        zoomWindowFadeIn: 500,
        zoomWindowFadeOut: 750
    });

   	//product image popup
     $('body').on('click', '#productPhotoImg', function(e) {
       var images = new Array();
       //images[0] = {
       // src : document.getElementById('productPhotoImg').dataset.zoomImage,
       //  type : 'image'
       //};
       if($('#productThumbs').length > 0) {
         var ind = 0;
         $('#productThumbs a[data-zoom-image] img').each(function() {
           var i = {
             src : $(this).data('grande'),
             type : 'image'
           };
           //if( i.src != images[0].src ) {
             images[ind] = i;
             ind++;
           //} //else { console.log(images[0].src); }
         });
       }
       
       

       return false;
     });

  $("#productThumbs a[data-zoom-image]").click(function() {
    $("#productPhotoImg").data('position', $(this).data('position')).data('zoom-image', $(this).data('image'));
    var myVar = setInterval(function(){ // wait for fading
        var height = $(".zoom").css("height");
        $(".zoomContainer").css("height", height);
        $(".zoomContainer .zoomWindow").css("height", height);

        clearInterval(myVar);
    }, 100);
  });



  
   

  
  
  
  
  
  $('a#more-action').on('click', function() {
    $("html, body").animate({
      scrollTop: $("#more-anchor").offset().top
    }, 1000);

    return false;
  });
  $('a#reviews-action').on('click', function() {
    $("html, body").animate({
      scrollTop: $("#all-reviews").offset().top
    }, 1000);

    return false;
  });
});
